import { defineStore } from "pinia";
import { Modal } from "ant-design-vue";

import pb from "@pb/index.json";
import eventsCenter, { EVENTCMD } from "@js/events";
import { isGameHtml } from "@js/utils";
import Logger from "@js/logger";
import * as Accounts from "@js/account";
import BusinessManager from "@js/controls";
import CheckIfExistGamingWindow from "@js/checkGameingWindow";
import { usePlayGameStore } from "@/store/playGame";
import IPCCenter from "@js/ipc";

const PLAYERSTATUS = pb.nested.yunpb.nested.PlayerStatus.values;
const PlayerStatusType = pb.nested.yunpb.nested.PlayerStatusType.values;

export const usePlayStatusStore = defineStore("playStatus", {
  state: () => ({}),
  actions: {
    setup() {
      const playGameStore = usePlayGameStore();
      eventsCenter.on(
        EVENTCMD.PlayerStatus,
        async (msg: { cmd: number; obj: pro.yunpb.IGetPlayerStatusRes }) => {
          console.log("接收用户状态推送", msg);

          const { obj } = msg;

          // 游戏页面暂时先忽略这个消息，这个判断以后要改为用通用路由去判断
          if (isGameHtml()) {
            return;
          }

          switch (obj.status) {
            // 空闲
            case PlayerStatusType.FREE: {
              Logger.log(`handlePlayStatusMessage FREE`);
              playGameStore.resetModalState();
              playGameStore.isQueueing = false;
              Accounts.setCurrentGame(null);
              break;
            }
            // 排队中
            case PlayerStatusType.IN_QUEUE: {
              Logger.log(`handlePlayStatusMessage IN_QUEUE`);
              Accounts.setCurrentGame(obj.gameNode!);
              playGameStore.isQueueing = true;
              playGameStore.showFloatModal({
                playerOper: PLAYERSTATUS.IN_QUE,
                queIndex: obj.queIndex,
                waitTime: obj.waitTime,
                queueInfo: obj.queueInfo,
              });
              break;
            }
            // 排队后错过进入游戏时机
            case PlayerStatusType.MISS_ENTER_GAME: {
              Logger.log(`handlePlayStatusMessage MISS_ENTER_GAME`);
              playGameStore.resetModalState();
              playGameStore.isQueueing = false;
              BusinessManager.ConfirmAlreadyMissStatus();
              Accounts.setCurrentGame(null);
              Modal.confirm({
                title: "Tips",
                content: "Your queue has been missed, please queue again.",
                okText: "Requeue",
                cancelText: "Cancle",
                centered: true,
                onOk: () => {
                  // 请求清理字段
                  playGameStore.handlePlayGameMessage(obj.gameNode!);
                  BusinessManager.ConfirmAlreadyMissStatus();
                },
                onCancel: () => {
                  BusinessManager.ConfirmAlreadyMissStatus();
                },
              });
              break;
            }
            // 能进入游戏了
            case PlayerStatusType.CAN_ENTER_GAME: {
              Logger.log(`handlePlayStatusMessage CAN_ENTER_GAME`);

              const { node } = obj;
              Accounts.setCurrentGame(obj.gameNode!);
              node?.id && Accounts.setGameUid(node.id);
              node && Accounts.setCurrentGameNode(node);
              playGameStore.isQueueing = false;
              playGameStore.queueData = {
                ...playGameStore.queueData,
                playerOper: PLAYERSTATUS.NO_OPER,
                countDown: obj.enterGameCountdownTime,
              };

              if (!isGameHtml()) {
                Modal.destroyAll();
                playGameStore.showQueueModal({});
                IPCCenter.getInstance().broadCastEvent(
                  EVENTCMD.StartCountDown,
                  {}
                );
              }
              break;
            }
            // 可重返游戏
            case PlayerStatusType.CAN_RETURN_GAME: {
              Logger.log(`handlePlayStatusMessage CAN_RETURN_GAME`);

              const { node } = obj;
              node?.id && Accounts.setGameUid(node.id);
              node && Accounts.setCurrentGameNode(node);

              if (!isGameHtml()) {
                playGameStore.isQueueing = false;
                const exist: boolean =
                  await CheckIfExistGamingWindow.checkIfExistGamingWindow();
                Accounts.setCurrentGame(obj.gameNode!);

                if (exist) {
                  playGameStore.showFloatModal({
                    playerOper: PLAYERSTATUS.NO_OPER,
                  });
                } else {
                  if (playGameStore.isFirstLoadGameNotOver) {
                    // console.log('connect isFirstLoadGameNotOver: ', isFirstLoadGameNotOver);
                    playGameStore.isFirstLoadGameNotOver = false;
                    // Modal.destroyAll();
                    // 只有进入首页刷新
                    Modal.confirm({
                      title: "Tips",
                      content:
                        "Your game is not over. Do you want to continue the game?",
                      okText: "Continue",
                      cancelText: "Cancle",
                      centered: true,
                      onOk: () => {
                        playGameStore.isFirstLoadGameNotOver = true;
                        return new Promise((resolve, reject) => {
                          playGameStore
                            .handleOpenGame()
                            .then((res) => resolve(res));
                        });
                      },
                      onCancel: () => {
                        playGameStore.isFirstLoadGameNotOver = true;
                        return new Promise((resolve, reject) => {
                          playGameStore
                            .handleCancelBackGame()
                            .then((res) => resolve(res));
                        });
                        // dispatch({ type: 'playGame/handleCancelBackGame' });
                      },
                    });
                  }
                }
              }
              break;
            }
            default:
              break;
          }
        }
      );
    },
  },
});
